import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { MetricComponent } from "@/types/insights";
import { Minus, TrendingDown, TrendingUp } from "lucide-react";
import {
  formatMetricDelta,
  formatMetricValue,
  metricCardClassNames,
  metricValueClassNames,
  sentimentBadgeClassNames,
} from "./insights-component-utils";

export const InsightsMetricCard = ({ component }: { component: MetricComponent }) => {
  const sentiment = component.sentiment ?? "neutral";
  const delta = component.delta;
  const deltaLabel = component.deltaLabel;
  const hasDelta = delta !== null && delta !== undefined;

  const DeltaIcon =
    delta === undefined || delta === null || delta === 0
      ? Minus
      : delta > 0
        ? TrendingUp
        : TrendingDown;

  return (
    <Card
      className={cn(
        "min-h-36 min-w-[14rem] gap-4 px-5 py-5 shadow-sm",
        metricCardClassNames[sentiment]
      )}
    >
      <div className="space-y-2">
        <p className="text-sm font-medium leading-5 text-muted-foreground">{component.title}</p>
        <div className={cn("text-3xl font-semibold tracking-tight", metricValueClassNames[sentiment])}>
          {formatMetricValue(component.value, component.unit)}
        </div>
      </div>

      {(hasDelta || deltaLabel) && (
        <div className="mt-auto flex flex-wrap items-center gap-2">
          {hasDelta ? (
            <span
              className={cn(
                "inline-flex items-center gap-1 rounded-full border px-2 py-1 text-xs font-medium",
                sentimentBadgeClassNames[sentiment]
              )}
            >
              <DeltaIcon className="size-3.5" />
              {formatMetricDelta(delta, component.unit)}
            </span>
          ) : null}
          {deltaLabel ? (
            <span className="text-xs leading-5 text-muted-foreground">{deltaLabel}</span>
          ) : null}
        </div>
      )}
    </Card>
  );
};
